
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SLEntity } from './entity';
import { SLEntityService, SLEntityFilter } from './entity.service';
import { SLEntityFilterDialogComponent } from './entity-filter-dialog.component';
import { NotifierService, DialogService } from '../../ui';

const FILTER_KEY = 'entities.filter';

@Component({
  templateUrl: './entity-list.component.html',
})
export class SLEntityListComponent implements OnInit {

  filter: SLEntityFilter;

  perPage = 10
  entitiesCount: number = 0
  entities: SLEntity[]

  constructor(
    private entityService: SLEntityService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new SLEntityFilter();

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.entities.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.entityService
      .entities(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.entities = result.entities;
        }
        // Append
        else {
          this.entities = [...this.entities || [], ...result.entities];
        }

        this.entitiesCount = result.entitiesCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showSLEntity(entity: SLEntity, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['shares-ledger', 'entities', entity.id]);
    }
  }

  applyFilter() {
    this.dialogService.show({
      component: SLEntityFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: SLEntityFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }

  clearHasMovements() {
    this.filter.hasMovements = undefined;

    this.fetch(0, this.perPage, true);
  }
}
